"use client";
import { ErrorCard } from "@/components/ui/ErrorCard";
export default function Error(props: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <ErrorCard
      {...props}
      heading="Artikel konnte nicht geladen werden"
      message="Bitte versuchen Sie es erneut."
      logPrefix="four-axes-article"
    />
  );
}
